module.exports = __webpack_public_path__ + "184e3081f82f150d1f654b2dbeadd0a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/ads/visa_sample_ad.jpg
// module id = 1611
// module chunks = 0